const forgotPasswordValidation = (values, name, stateErrors) => {
	let errors = { ...stateErrors }

	switch (name) {
		case 'email':
			if (!values.email) {
				errors.email = 'Необходимо указать почту'
			} else if (
				!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
			) {
				errors.email = 'Почта введена неверно'
			} else {
				delete errors.email
			}
			break
		default:
			console.log('There is no input with this name in the /forgot-password form')
	}

	return errors
}

export default forgotPasswordValidation
